import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { JwtAuthService } from '../services/auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class DefaultRedirectGuard implements CanActivate {
  constructor(private router: Router, private jwtAuth: JwtAuthService) {}

  canActivate(): UrlTree {
    if (!this.jwtAuth.isLoggedIn()) {
      return this.router.createUrlTree(['/sessions/signin']);
    }

    const userType = this.jwtAuth.getUser();

    if (['merchant', 'supplier'].includes(userType)) {
      return this.router.createUrlTree(['/sales/bookings']);
    }

    return this.router.createUrlTree(['/cms/home']);
  }
}
